/** Client-side metric labels shared by dashboard + analytics pages. */
export const METRIC_LABELS_FALLBACK: Record<string, string> = {
  impressions: 'Impressions',
  reach: 'Reach',
  engagements: 'Engagements',
  likes: 'Likes',
  comments: 'Comments',
  shares: 'Shares',
  clicks: 'Clicks',
  saves: 'Saves',
  video_views: 'Video views',
};
